import { render, staticRenderFns } from "./DocLinkDrawer.vue?vue&type=template&id=6a8e8ee3&scoped=true&"
import script from "./DocLinkDrawer.vue?vue&type=script&lang=js&"
export * from "./DocLinkDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DocLinkDrawer.vue?vue&type=style&index=0&id=6a8e8ee3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e8ee3",
  null
  
)

export default component.exports